module.exports = __webpack_public_path__ + "static/media/GPC_vector.c10421cd.svg";